<!--
 * @Author: Jacob.Zhang
 * @Description: 个人信息表 - 主申请人信息
-->
<template>
    <!-- 回显信息 -->
    <div ref="userDetail" class="details-module common-part">
        <!-- 主申请人信息 -->
        <el-row :gutter="15">
            <el-col :span="12" id="username">
                <span>主申姓名：</span>
                <span>{{ info.username }}</span>
            </el-col>
            <el-col :span="12" id="used_name">
                <span>曾用名：</span>
                <span>{{ info.used_name }}</span>
            </el-col>
            <el-col :span="12" id="used_name">
                <span>婚前姓氏：</span>
                <span>{{ info.surname || "-"  }}</span>
            </el-col>
            <el-col :span="12" id="username_pinyin">
                <span>姓名拼音：</span>
                <span>{{ info.username_pinyin.family_name + ' ' + info.username_pinyin.given_name }}</span>
            </el-col>
            <el-col :span="12" id="user_sex">
                <span>性别：</span>
                <span>{{ info.sex | _sex }}</span>
            </el-col>
            <el-col :span="12" id="user_birthday">
                <span>出生日期：</span>
                <span>{{ `${info.birthday}` }}（<span class="text-red">{{ `${dataList[0].age}岁` }}</span>）</span>
            </el-col>
            <el-col :span="12" id="birth_place_aboard">
                <span>出生城市：</span>
                <span v-if="info.birth_place_aboard === 1">{{ info.birth_place.foreign }}</span>
                <span v-if="info.birth_place_aboard === 0">{{ info.birth_place.details }}</span>
            </el-col>
            <el-col :span="12" id="user_mobile">
                <span>登录手机号：</span>
                <span>{{ info.mobile }}</span>
                <a class="link-a" @click="toCustomerDetails">修改</a>
            </el-col>
            <el-col :span="12">
                <span>邮箱：</span>
                <span>{{ info.email }}</span>
            </el-col>
            <el-col :span="12" id="user_married">
                <span>婚姻状况：</span>
                <span>{{ info.married | _married }}</span>
            </el-col>
            <el-col :span="12" id="user_nationality">
                <span>国籍：</span>
                <span>{{ info.nationality }}</span>
            </el-col>
            <el-col :span="inChina ? 24 : 12" id="user_address">
                <span>现居住地址：</span>
                <span id="user_address_detail">{{ info.address.country + '-' + (inChina ? (info.address.area.join('') + info.address.details) : info.address.foreign) }}</span>
            </el-col>
            <el-col :span="12" id="user_address" v-if="!inChina">
                <span>是否居住满一年及以上：</span>
                <span>{{ info.is_live_oversea_year === 1 ? '是' : '否' }}</span>
            </el-col>
            <el-col :span="12">
                <span>是否办理过香港身份证：</span>
                <span class="text-red">{{ info.has_hk_id | hasHkid }}</span>
            </el-col>
            <el-col :span="12" id="user_hk_id_number">
                <span>香港身份证号码：</span>
                <span>{{ info.has_hk_id === 1 ? info.hk_id_number : '-' }}</span>
            </el-col>
            <el-col :span="12" v-if="showPlan">
                <span>身份计划：</span>
                <span>{{ formatValue(info,'identity_plan') }}</span>
            </el-col>

            <template v-if="showPlan && (info.identity_plan === 1 || info.identity_plan === 2)">
                <el-col :span="12">
                    <span>收入分类：</span>
                    <span>{{ formatValue(info,'income_category') }}</span>
                </el-col>

                <el-col :span="12">
                    <span>收入细化类别：</span>
                    <span>{{ formatValue(info,'income_detail_type') }}</span>
                </el-col>

                <el-col :span="12">
                    <span>赴港同意书提供单位：</span>
                    <span>{{ formatValue(info,'approval_unit') }}</span>
                </el-col>

                <el-col :span="12">
                    <span>预计递交时间：</span>
                    <span>{{ info.ready_to_submit_at }}</span>
                </el-col>

                <el-col :span="12">
                    <span>是否孵化：</span>
                    <span>{{ formatValue(info,'is_incubated') }}</span>
                </el-col>

                <el-col :span="12" v-if="info.is_incubated === 1">
                    <span>孵化卡点：</span>
                    <span>{{ formatValue(info,'incubation_bottleneck') }}</span>
                </el-col>

                <el-col :span="12" v-if="info.identity_plan === 1 && info.is_incubated === 1">
                    <span>孵化项目：</span>
                    <span>{{ formatValue(info,'incubation_project') }}</span>
                </el-col>

                <el-col :span="12" v-if="info.identity_plan === 2 && info.is_incubated === 1">
                    <span>孵化情况：</span>
                    <span>{{ formatValue(info,'incubation_status') }}</span>
                </el-col>

                <el-col :span="12" v-if="info.identity_plan === 1 && Array.isArray(info.incubation_project) && info.incubation_project.includes(1)">
                    <span>考试类别：</span>
                    <span>{{ formatValue(info,'exam_types') }}</span>
                </el-col>

                <el-col :span="12" v-if="info.identity_plan === 1 && Array.isArray(info.incubation_project) && info.incubation_project.includes(1)">
                    <span>考试时间：</span>
                    <span>{{ info.exam_date }}</span>
                </el-col>

                <el-col :span="12" v-if="info.identity_plan === 1 && Array.isArray(info.incubation_project) && info.incubation_project.includes(2)">
                    <span>预计学位授予时间：</span>
                    <span>{{ info.expected_degree_award_date }}</span>
                </el-col>

                <el-col :span="12" v-if="info.identity_plan === 1 && Array.isArray(info.incubation_project) && info.incubation_project.includes(3)">
                    <span>预计达标时间：</span>
                    <span>{{ info.expected_achievement_date }}</span>
                </el-col>
            </template>
        </el-row>
        <!-- 证件 -->
        <template v-for="(item, key) in info.certificates">
            <el-row :key="key" :gutter="15">
                <el-divider />
                <el-col :span="24" :id="`${key}_name`">
                    <span>证件类别：</span>
                    <span v-if="key === 'passport'">{{ item.passport_type | _passportType }}</span>
                    <span v-else>{{ key | _certificates }}</span>
                </el-col>
                <el-col :span="12" :id="`${key}_number`">
                    <span>证件号码：</span>
                    <span>{{ item.number }}</span>
                </el-col>
                <el-col :span="12" :id="`${key}_issue_at`">
                    <span>签发地：</span>
                    <span>{{ item.issue_at }}</span>
                </el-col>
                <el-col :span="12" :id="`${key}_issue_date_start_at`">
                    <span>签发日期：</span>
                    <span>{{ item.issue_date_start_at }}</span>
                </el-col>
                <el-col :span="12" :id="`${key}_issue_date_end_at`">
                    <span>届满日期：</span>
                    <span>{{ item.issue_date_end_at }}</span>
                </el-col>
            </el-row>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getOrderServerList } from '../../../../../api/gifted'
export default {
    filters: {
        hasHkid(val) {
            switch (val) {
                case 0:
                    return '否'
                case 1:
                    return '是'
                default:
                    return '-';
            }
        }
    },
    props: {
        info: {
            type: Object,
            default() {
                return {}
            }
        },

        selectOptions: {
            type: Object,
            default: () => ({
                identity_plan: [],
                income_category: [],
                income_detail_type: [],
                approval_unit: [],
                exam_types: [],
                is_incubated:[
                    { label: '是', value: 1 },
                    { label: '否', value: 2 },
                ],
                incubation_status: [],
                incubation_project: [],
                incubation_bottleneck: [],
            })
        }
    },
    computed: {
        ...mapState('gifted', ['dataList']),
        inChina() {
            return !!(this.info.address.country && this.info.address.country.includes('中国'))
        },
        showPlan(){
            return this.$route.query.system_name && this.$route.query.system_name === 'CRM-server'
        },
    },
    methods: {
        // 跳转合同详情
        async toCustomerDetails() {
            try {
                const { auth_sign, customer_id, client_id, order_sn, test_login_user_id } = this.$route.query
                const res = await getOrderServerList({ auth_sign, customer_id, client_id, order_sn, test_login_user_id })
                if (res.code !== 200) {
                    return
                }
                const { id, auth_contracts_sign } = res.data.data[0] || {}
                window.open(`${process.env.VUE_APP_CRM_URL}/Customer/Details?id=${id}&auth_sign=${auth_contracts_sign}`, '_blank')
            } catch (error) {
                console.log('Error: ' + error);

            }
        },
        formatValue(obj, key) {
            const value = obj[key]
            if (Array.isArray(value)) {
                return this.selectOptions[key].filter(item => value.includes(item.value)).map(item => item.label).join(';') || '-'
            } else {
                return this.selectOptions[key].find(item => item.value === value)?.label || '-'
            }
        }
    }
}
</script>

<style lang="less" scoped>
#user_address {
    align-items: flex-start;

    &_detail {
        padding-right: 15px;
    }
}
.link-a {
    margin-left: 12px;
    color: #409eff !important;
    cursor: pointer;
}
</style>
